'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _handleActions;

import { handleActions, combineActions } from 'flux-actions';
import * as ActionTypes from '../actions/ActionTypes';
var initialState = null;
export default handleActions((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SET_FORM_STATE, function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions, combineActions(ActionTypes.RESET_FORM_STATE, ActionTypes.BOOKING_TIME_CONFLICT), function () {
  return initialState;
}), _handleActions), initialState);